import { z } from 'zod';

export const createCategorySchema = z.object({
  name: z.string().min(1).max(100),
  sortOrder: z.number().int().min(0).max(1000).optional(),
});

export const updateCategorySchema = createCategorySchema.partial().extend({
  archived: z.boolean().optional(),
});

export type CreateCategoryInput = z.infer<typeof createCategorySchema>;
export type UpdateCategoryInput = z.infer<typeof updateCategorySchema>;

/**
 * Attach by id when the planner picked from the master list, by name when they
 * typed something new. From inside a wedding those two cases are
 * indistinguishable to the planner, so the name form resolves to whichever
 * master row ends up existing rather than failing on a collision.
 */
export const attachWeddingCategorySchema = z.union([
  z.object({ categoryId: z.string().uuid() }),
  z.object({ name: z.string().trim().min(1).max(100) }),
]);

export type AttachWeddingCategoryInput = z.infer<typeof attachWeddingCategorySchema>;
